import cn from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { NavItemProps } from "./NavItem.types";

import styles from "./NavItem.module.scss";

const NavItem = ({ route, counter = 0, isNested = false }: NavItemProps) => {
  const { t } = useTranslation();

  return (
    <NavLink
      to={route.path ?? "/page-not-found"}
      className={({ isActive }) =>
        cn(styles.link, {
          [styles["link--active"]]: isActive,
          [styles["link--nested"]]: isNested
        })
      }
    >
      <div className={styles.link__icon}>{route.icon}</div>
      <p className={styles.link__text}>{t(route.label)}</p>

      {counter > 0 && <div className={styles.link__badge}>{counter}</div>}
    </NavLink>
  );
};

export default NavItem;
